import jstz from 'jstz'

export default function timeZoneSelect (select) {

  if (!select) return;
  if (!!document.getElementById('edit_user')) return;
  select.value = jstz.determine().name()

}
